<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Validation
      <div slot="right" class="navbar-message button-gap-right-aligned">
        <div class="hero-navbar-right-flex">
          <b-button
            type="is-normal"
            class="import-button"
            @click="backToImport"
          >
            Cancel</b-button
          >
          <b-button
            type="is-primary"
            class="import-button"
            @click="isCardModalActive = true"
            v-if="
              (checkCurrentStatus('In Validation') ||
                checkCurrentStatus('Partial Import') ||
                checkCurrentStatus('Auto-Validation Failed') ||
                checkCurrentStatus('Complete')) &&
                isEditAllowed
            "
          >
            Update Status</b-button
          >
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <section class="has-listing-table validation-collapse">
        <div class="level no-margin">
          <div
            class="level-left validation-collapse-header-text"
            @click="togglePanel"
          >
            <h3 class="import-type-name">
              General Import Information ({{ importData.customer_name }})
            </h3>
            <b-icon :icon="isOpen ? 'chevron-up' : 'chevron-down'"></b-icon>
          </div>

          <div class="level-right validation-toggole-level">
            <span>Current Status:</span><span> &nbsp;</span>
            &nbsp;
            <b-icon
              icon="timer-sand"
              v-if="checkCurrentStatus('In Validation')"
              custom-size="default"
            ></b-icon>
            <b-icon
              icon="alert-circle"
              v-if="checkCurrentStatus('Failed')"
              custom-size="default"
              type="is-danger"
            ></b-icon>
            <b-icon
              icon="check-all"
              v-if="checkCurrentStatus('Completed and Validated')"
              custom-size="default"
              type="is-success"
            ></b-icon>
            <b-icon
              icon="check"
              v-if="checkCurrentStatus('Complete')"
              custom-size="default"
              type="is-success"
            ></b-icon>
            <span>{{ importData.status }}</span>
          </div>
        </div>
        <b-collapse class="validation-panel" animation="slide" :open="isOpen">
          <div class="card validation-card">
            <div class="card-content">
              <div class="columns">
                <div class="column columns no-margin">
                  <div class="column icon-column">
                    <b-icon icon="account-circle"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns validation-text-header">
                      Customer Name
                    </div>
                    <div class="columns">
                      <h3 class="no-padding">{{ importData.customer_name }}</h3>
                    </div>
                  </div>
                </div>
                <div class="column columns no-margin">
                  <div class="column icon-column">
                    <b-icon icon="calendar-blank-outline"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns validation-text-header">
                      Import Type
                    </div>
                    <div class="columns">
                      <h3 class="no-padding">{{ importData.import_type }}</h3>
                    </div>
                  </div>
                </div>
                <div class="column columns no-margin">
                  <div class="column icon-column">
                    <b-icon icon="account"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns validation-text-header">
                      Imported By
                    </div>
                    <div class="columns">
                      <h3 class="no-padding">
                        {{ importData.imported_by_user }}
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="column columns no-margin">
                  <div class="column icon-column">
                    <b-icon icon="notebook"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns no-padding validation-text-header">
                      Comment
                    </div>
                    <div class="columns">
                      <a
                        ref="#"
                        @click.prevent="showComments(importData.comment)"
                        ><h3 class="no-padding validation-import-comments">
                          See Comments
                        </h3></a
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="column columns no-margin"
                  v-if="importData.import_type != 'Products'"
                >
                  <div class="column icon-column">
                    <b-icon icon="calendar-clock"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns no-padding validation-text-header">
                      Period
                    </div>
                    <div class="columns">
                      <h3 class="no-padding">{{ importData.period }}</h3>
                    </div>
                  </div>
                </div>
                <div class="column columns no-margin" v-else></div>
              </div>
              <div class="columns">
                <div class="column columns no-margin">
                  <div class="column icon-column">
                    <b-icon icon="notebook"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns no-padding validation-text-header">
                      Attached Documents
                    </div>
                    <div class="columns">
                      <a ref="#" @click.prevent="isFileListActive = true"
                        ><h3 class="no-padding validation-import-comments">
                          See Lists
                        </h3></a
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="column columns no-margin"
                  v-if="
                    this.importType == 'Products' &&
                      checkCurrentStatus('Partial Import') &&
                      !isViewOnly
                  "
                >
                  <div class="column icon-column">
                    <b-icon icon="account"></b-icon>
                  </div>
                  <div class="column is-three-quarters">
                    <div class="columns no-padding validation-text-header">
                      Data
                    </div>
                    <div class="columns">
                      <a ref="#" @click.prevent="isNewDataFileListActive = true"
                        ><h3 class="no-padding validation-import-comments">
                          Add data
                        </h3></a
                      >
                    </div>
                  </div>
                </div>
                <div class="column columns no-margin" v-else></div>
                <div class="column columns no-margin"></div>
                <div class="column columns no-margin"></div>
                <div class="column columns no-margin"></div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <section class="has-listing-table">
        <div class="level no-margin">
          <div class="level-left">
            <h3 class="import-type-name">{{ importData.import_type }}</h3>
            <h3
              class="navbar-item margin-top-bulk-edit"
              v-if="importData.import_type == 'Products'"
            >
              <a
                @click="editBulkModal()"
                data-cy="pd-bulk-edit"
                v-if="isEditAllowed"
                >Edit</a
              >
            </h3>
            <h3 class="navbar-item margin-top-bulk-edit">
              <a
                @click.prevent="additionalBulkCheck('exportProducts')"
                data-cy="pd-bulk-export"
                >Export</a
              >
            </h3>
            <h3
              class="navbar-item margin-top-bulk-edit"
              v-if="importData.import_type == 'Products'"
            >
              <a
                @click="openDataCompletionModal()"
                data-cy="data-completion"
                v-if="isEditAllowed"
                >Data Completion</a
              >
            </h3>
            <h3
              class="navbar-item margin-top-bulk-edit"
              v-if="!isViewOnly && importData.import_type == 'Products'"
            >
              <a
                @click.prevent="revertDataCompletionRule('revert')"
                data-cy="pd-bulk-edit"
                >Revert</a
              >
            </h3>
          </div>

          <div class="level-right page-configs">
            <template v-if="importData.import_type == 'Products'">
              <b-field>
                <b-select
                  placeholder="Default"
                  expanded
                  @input="streamChanged"
                  v-model="stream"
                >
                  <option selected value="PRODUCT SHEET">Products</option>
                  <option value="BATT" v-if="availableStream['BATT']">
                    Batteries
                  </option>
                  <option value="PACK" v-if="availableStream['PACK']">
                    Packaging
                  </option>
                  <option value="WEEE" v-if="availableStream['WEEE']">
                    WEEE
                  </option>
                  <option
                    value="BUNDLE INFORMATION"
                    v-if="availableStream['BUNDLE']"
                  >
                    Bundle
                  </option>
                </b-select>
              </b-field>
            </template>

            <!-- Column Configuration Dropdown -->
            <b-dropdown position="is-bottom-left" style="margin-bottom: 10px;">
              <template #trigger>
                <a class="navbar-item navbar-mdi-tune-dropdown">
                  <button class="button" data-cy="validation-config-button">
                    <span class="mdi mdi-table-cog mdi-24px mdi-dark"></span>
                  </button>
                </a>
              </template>
              <form>
                <div class="filter-config-modal-body">
                  <section class="filter-config-list">
                    <span>
                      <b-field label="Column Configuration"></b-field>
                    </span>
                    <div style="padding: 4px 0;">
                      <b-checkbox v-model="selectAll" @input="toggleSelectAll">
                        <strong>Select All</strong>
                      </b-checkbox>
                    </div>
                    <div
                      v-for="(column, index) in columns"
                      :key="index"
                      class="control"
                    >
                      <div
                        v-if="column.label != '' && column.field !== 'actions'"
                      >
                        <b-dropdown-item
                          aria-role="list"
                          :focusable="false"
                          custom
                          paddingless
                        >
                          <b-checkbox
                            @input="saveFieldConfig()"
                            v-model="column.visible"
                          >
                            {{ column.label }}
                          </b-checkbox>
                        </b-dropdown-item>
                      </div>
                    </div>
                  </section>
                </div>
              </form>
            </b-dropdown>
          </div>
        </div>
        <div class="enable-select-text">
          <circul8-table
            ref="circul8Table"
            @clickcheck="checkCheckBox"
            @checkedAll="checkedAllData"
            :checkedRows="checkedRow"
            :records="tableData"
            :fields="columns.filter(col => col.visible !== false)"
            :usePropRecords="true"
            :listingComponent="true"
            :isCheckable="true"
            :maxTextLength="'24'"
            :isLoading="isDataLoading"
            @querySet="searchByFilter"
            :backendSortingEnabled="true"
            @backendSort="sortData"
            @clickEdit="editModal"
            @clickView="viewModal"
            :enableSwitchAction="true"
            :showEditButton="checkEnableButton"
            :routeNext="false"
            :allProductFamily="productFamily"
            :allMaterialDetail="materialDetail"
            :showViewButton="checkEnableButton"
            :productFamilyDropDown="productFamilyDropDown"
            :materialDetailDropDown="materialDetailDropDown"
            :chemistryDropDown="chemistryDropDown"
            :packagingTypeDropDown="packagingTypeDropDown"
            :packagingLevelDropDown="packagingLevelDropDown"
          />
          <div class="records-displayed" v-if="totalRecords > 0">
            <span v-if="isCheckedAll"> All selected, </span>
            <span v-if="checkedData.length > 0 && !isCheckedAll"
              >{{ checkedData.length }} selected,
            </span>
            <span v-if="currentPage * 50 + 50 < totalRecords"
              >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
              {{
                currentPage > 0
                  ? nextPageCursor
                    ? currentPage * 50 - 50 + tableData.length
                    : totalRecords
                  : tableData.length
              }}
              records out of {{ totalRecords }} records</span
            >
            <div v-else>
              <span v-if="currentPage == 0">
                displaying 0 - {{ totalRecords }} records out of
                {{ totalRecords }} records
              </span>
              <span v-else>
                displaying {{ currentPage * 50 - 50 }} -
                {{ totalRecords }} records out of {{ totalRecords }} records
              </span>
            </div>
          </div>
        </div>
      </section>
    </section>
    <b-modal v-model="isCardModalActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-success">Update Status</p>
        </header>
        <section class="modal-card-body">
          <b-field
            label="Please select a status"
            v-if="checkCurrentStatus('Partial Import')"
          >
            <b-select expanded v-model="tempWorkflowStatus">
              <option
                v-for="(option, index) in importWorkFlowPartialStatus"
                :value="option"
                :key="index"
                selected
              >
                {{ option }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Please select a status" v-else>
            <b-select expanded v-model="tempWorkflowStatus">
              <option
                v-for="(option, index) in importWorkFlowStatus"
                :value="option"
                :key="index"
                selected
              >
                {{ option }}
              </option>
            </b-select>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Cancel"
            class="is-normal"
            @click="isCardModalActive = false"
          />
          <b-button label="Apply" type="is-primary" @click="tempStatusChange" />
        </footer>
      </div>
    </b-modal>
    <b-modal v-model="isFileListActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-success">Attached Documents</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Documents">
            <div
              class="tags"
              v-if="
                importData.cdf_document_all &&
                  importData.cdf_document_all.length > 0
              "
            >
              <span
                v-for="(file, index) in importData.cdf_document_all"
                :key="index"
                class="tag"
                @click.prevent="downloadContent(file)"
                ><a href="#"
                  >{{ getFileName(file.document) }}
                  <i class="mdi mdi-download"></i
                ></a>
              </span>
            </div>
            <div class="tags" v-else>
              <span
                v-for="(file, index) in importData.cdf_document"
                :key="index"
                class="tag"
                @click.prevent="downloadContent(file)"
                ><a href="#"
                  >{{ getFileName(file.document) }}
                  <i class="mdi mdi-download"></i
                ></a>
              </span>
            </div>
            <!-- <div class="tags" v-else>
              <span
                v-for="(file, index) in importData.cdf_document"
                :key="index"
                class="tag"
                @click.prevent="downloadContent(file)"
                ><a href="#"
                  >{{ getFileName(file.document) }}
                  <i class="mdi mdi-download"></i
                ></a>
              </span>
            </div> -->
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Cancel"
            class="is-normal"
            @click="isFileListActive = false"
          />
        </footer>
      </div>
    </b-modal>
    <b-modal v-model="isNewDataFileListActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-success">Attached Documents</p>
        </header>
        <section class="modal-card-body">
          <form @submit.prevent="submit">
            <div class="columns no-margin-bottom">
              <section>
                <p>
                  Please upload only Error Document with corrected data related
                  to this import
                </p>
                <b-field
                  label="Choose a document to attach (CSV, XLSX or XLS)*"
                ></b-field>
                <b-field required class="file is-primary">
                  <b-upload
                    required
                    v-model="addDataDocument"
                    class="file-label"
                    multiple
                    drag-drop
                  >
                    <span>
                      <section class="section">
                        <div class="content has-text-centered">
                          <p>
                            <b-icon icon="upload" size="is-large"> </b-icon>
                          </p>
                          <p>Drop your files here or click to upload</p>
                        </div>
                      </section>
                    </span>
                  </b-upload>
                </b-field>
                <div class="tags">
                  <span
                    v-for="(file, index) in addDataDocument"
                    :key="index"
                    class="tag is-primary"
                  >
                    {{ file.name }}
                    <button
                      class="delete is-small"
                      type="button"
                      @click="deleteFile(index)"
                    ></button>
                  </span>
                </div>
              </section>
            </div>
            <div class="columns"></div>
          </form>
        </section>
      </div>
      <footer class="modal-card-foot">
        <b-button
          label="Cancel"
          class="is-normal"
          @click="isNewDataFileListActive = false"
        />
        <b-button label="Apply" type="is-primary" @click="submit" />
      </footer>
    </b-modal>
    <b-modal has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-success">Load data</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Documents">
            <div class="tags">
              <span
                v-for="(file, index) in importData.cdf_document_all"
                :key="index"
                class="tag"
                @click.prevent="downloadContent(file)"
                ><a href="#"
                  >{{ getFileName(file.document) }}
                  <i class="mdi mdi-download"></i
                ></a>
              </span>
            </div>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Loads"
            class="is-normal"
            @click="isFileListActive = false"
          />
        </footer>
      </div>
    </b-modal>
    <single-product-edit
      :is-active="isModalActive"
      :customer-id="Number(this.customer_id)"
      :action="action"
      :edit-object-name="editObject"
      @confirm="editConfirm"
      @cancel="editCancel"
      :columns="this.columns"
      @updateSingleData="updatedSingleProduct"
      :allProductFamily="productFamily"
      :allMaterialDetail="materialDetail"
      :columnsConfig="this.cdf_product_config_sheet"
      :materialGeneralDropdown="materialGeneralDropdown"
      :chemistryDropDown="chemistryDropDown"
      :packagingTypeDropDown="packagingTypeDropDown"
      :packagingLevelDropDown="packagingLevelDropDown"
    />
    <bulk-product-edit
      v-if="importData.import_type == 'Products'"
      :is-active="isCardModalBulkEditActive"
      :customer-id="Number(this.customer_id)"
      @cancel="editBulkCancel"
      :columns="this.columns"
      :columnsConfig="this.cdf_product_config_sheet"
      :checkedRows="this.checkedRow"
      :isCheckedAllRows="this.isCheckedAll"
      :stream="this.stream"
      :tempProduct="true"
      @reload="reloadProductData"
      :query="this.query"
    />
    <bulk-product-export
      @confirm="viewConfirmExport"
      @cancel="viewCancel"
      :is-active="isBulkExportModal"
    >
    </bulk-product-export>
    <data-completion
      :columns="this.columns"
      :columnsConfig="this.cdf_product_sheet"
      :checkedRows="this.checkedRow"
      :isCheckedAllRows="this.isCheckedAll"
      :stream="this.stream"
      :tempProduct="true"
      @reload="reloadProductData"
      :query="this.query"
      :customer-id="importData.customer"
      :is-active="isDataCompletion"
      @cancel="dataCompletionCancel"
    >
    </data-completion>
    <b-loading
      :is-full-page="true"
      v-model="isStatusLoading"
      :can-cancel="false"
    ></b-loading>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import CDFProductDataService from "../../services/CDFProductDataService";
import CDFTransactionDataService from "../../services/CDFTransactionDataService";
import DataManagementService from "../../services/DataManagementImportService";
import Circul8Table from "../../components/Circul8Table.vue";
import { CDFStream } from "../../constants/CDFStream";
import { FieldType } from "../../constants/FieldType";
import { ImportCDFWorkflowStatus } from "../../constants/ImportCDFWorkflowStatus";
import SingleProductEdit from "@/components/DataManagement/SingleProductEdit";
import BulkProductEdit from "@/components/DataManagement/BulkProductEdit";
import BulkProductExport from "@/components/DataManagement/BulkProductExport.vue";
import DataCompletion from "@/components/DataManagement/DataCompletion.vue";
import { UserGroup } from "@/services/UserGroups";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
import ProductMixin from "@/mixins/ProductMixin";
import ErrorMixin from "@/mixins/ErrorMixin";
import dayjs from "dayjs";
let screenPixelSize;
let pixelRatio;
export default {
  name: "DataManagementValidation",
  mixins: [UtilityMixin, ProductMixin, ErrorMixin],
  components: {
    HeroBar,
    TitleBar,
    Circul8Table,
    BulkProductEdit,

    SingleProductEdit,
    BulkProductExport,
    DataCompletion
  },
  data() {
    return {
      isStreamChanging: false,
      checkEnableButton: true,
      checkedData: [],
      checkedRow: [],
      map1: new Map(),
      isCheckedAll: false,
      checkedDataMap: new Map(),
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      tblName: "Validation",
      selectAll: true,
      //   displayedRecords: 0,
      totalRecords: 0,
      isBulkExportModal: false,
      isLoading: false,
      nextData: false,
      previousData: false,
      currentPage: 0,
      query: "",
      isDataLoading: false,
      isStatusLoading: false,
      isCardModalActive: false,
      isCardModalBulkEditActive: false,
      isFileListActive: false,
      isNewDataFileListActive: false,
      tempWorkflowStatus: null,
      importData: [],
      addDataDocument: [],
      isOpen: false,
      stream: "PRODUCT SHEET",
      availableStream: {},
      cdf_product_sheet: [],
      cdf_product_config_sheet: [],
      customer_id: "",
      parent_customer_id: null,
      tableData: [],
      customerDataService: new CustomerProfileDataService(),
      CDFProductDataService: new CDFProductDataService(),
      CDFTransactionDataService: new CDFTransactionDataService(),
      DataManagementService: new DataManagementService(),
      importId: this.$route.params.id,
      url: window.location.href,
      columns: [],
      importWorkFlowStatus: [
        ImportCDFWorkflowStatus.COMPLETED_AND_VALIDATED,
        ImportCDFWorkflowStatus.DISCARDED
      ],
      importWorkFlowPartialStatus: [ImportCDFWorkflowStatus.DISCARDED],
      currentStatus: this.$route.params.row?.status,
      isModalActive: false,
      editObject: {},
      action: "",
      productFamily: {},
      materialDetail: {},
      subHeight: 355,
      dataValidationDropDownTD: [],
      dataValidationDropDownPD: [],
      productFamilyDropDown: [],
      productGroupDropDown: [],
      materialDetailDropDown: [],
      materialGeneralDropdown: [],
      packagingTypeDropDown: [],
      packagingLevelDropDown: [],
      chemistryDropDown: [],
      exportLargeCount: 65000,
      isDataCompletion: false
    };
  },
  computed: {
    importType() {
      if (this.importId && this.url.includes("/product")) {
        return "Products";
      } else {
        return "Transactions";
      }
    },
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    isEditAllowed() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        // this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE)
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      } else {
        return false;
      }
    },
    isViewOnly() {
      if (
        this.userGroups.includes(UserGroup.VIEW_ONLY) //||
        // this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE) ||
        // this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      } else {
        return false;
      }
    },
    titleStack() {
      return [
        { url: "#", name: "Data Management" },
        { url: "/datamangement/import", name: "Import" },
        { url: "#", name: "Validation" }
      ];
    }
  },
  mounted() {
    this.checkExternalPermission();
    if (
      this.currentStatus == ImportCDFWorkflowStatus.IMPORT_COMPLETE ||
      this.currentStatus == ImportCDFWorkflowStatus.AUTO_VALIDATION_COMPLETED ||
      this.currentStatus == ImportCDFWorkflowStatus.AUTO_VALIDATION_FAILED
    ) {
      this.updateImportStatus(ImportCDFWorkflowStatus.IN_VALIDATION);
    } else {
      this.fetchCDFImportData();
    }
    if (this.importType == "Transactions") {
      this.checkEnableButton = false;
    } else {
      this.checkEnableButton = this.isEditAllowed;
    }

    if (!this.currentStatus && localStorage.tempTableStatus) {
      this.currentStatus = localStorage.tempTableStatus;
    } else {
      localStorage.tempTableStatus = this.currentStatus;
    }

    // there is no function implementation and getiing error in console for this. For these reasons commented out
    //this.fetchCustomerData();
    if (this.$route.params.customer) {
      this.form.customer = this.$route.params.customer;
    }
    if (this.$route.params.importType) {
      this.form.importType = this.$route.params.importType;
    }
  },
  watch: {
    columns: {
      handler() {
        const allSelected = this.columns.every(
          col => col.visible === true || col.field === "actions"
        );
        this.selectAll = allSelected;
      },
      deep: true
    }
  },
  updated() {
    const listElm = document.querySelector(".table-wrapper");
    listElm.addEventListener("scroll", () => {
      if (
        Math.round(listElm.scrollTop) +
          Math.round(listElm.clientHeight) -
          Math.round(listElm.scrollHeight) >=
        -5
      ) {
        if (this.nextData) {
          listElm.scrollTop = 50;
          this.pullNextPage();
        }
      } else {
        if (Math.round(listElm.scrollTop) == 0 && this.previousData) {
          listElm.scrollTop =
            Math.round(listElm.scrollHeight) -
            Math.round(listElm.clientHeight) -
            50;
          this.pullPreviousPage();
        }
      }
      this.checkSize();
      this.adjustHeight();
    });
  },
  methods: {
    toggleSelectAll() {
      // Toggle all columns except 'actions'
      const updated = this.columns.map(col => {
        if (col.field !== "actions") {
          return { ...col, visible: this.selectAll };
        }
        return col;
      });
      this.columns = updated;
      this.saveFieldConfig();
    },
    saveFieldConfig() {
      // Get visible column fields based on current checkbox selections
      const visibleFields = this.columns
        .filter(col => col.visible === true)
        .map(col => col.field);

      // Create a storage key that includes user ID, customer ID, import ID, and stream
      const customerId =
        this.customer_id ||
        (this.importData && this.importData.customer_id) ||
        (this.customer && this.customer.id) ||
        this.$route.params.customerId;
      const importId =
        this.importId ||
        (this.importData && this.importData.id) ||
        this.$route.params.id;
      const storageKey = `validation-field-config-${
        this.userId
      }-customer-${customerId}-import-${importId}-stream-${this.stream.replace(
        /\s+/g,
        "_"
      )}`;

      // Always save the user's exact column selection
      localStorage.setItem(storageKey, JSON.stringify(visibleFields));

      // Also save to the old key for backward compatibility
      localStorage.setItem(
        "validationMappingFields",
        JSON.stringify(visibleFields)
      );

      // Force a re-render of the table with only visible columns
      this.$nextTick(() => {
        if (this.$refs.circul8Table) {
          this.$refs.circul8Table.$forceUpdate();
        }

        // After the DOM update, recalculate the table height to fill available space
        this.adjustHeight();
      });
    },
    openDataCompletionModal() {
      if (this.checkedRow.length || this.isCheckedAll) {
        this.isDataCompletion = true;
      } else {
        this.$buefy.dialog.alert({
          title: "Warning",
          message: "Please choose the record(s) you want to update.",
          confirmText: "Close",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },

    dataCompletionCancel(str) {
      if (str !== "reload") {
        this.reloadProductData();
      }
      this.isDataCompletion = false;
    },
    deleteFile(index) {
      this.addDataDocument.splice(index, 1);
    },
    revertDataCompletionRule(bulkAction) {
      if (bulkAction == "revert") {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          message:
            "Are you sure you want to revert data completion rule on these records?",
          trapFocus: true,
          onConfirm: value => this.revertDc(value, bulkAction)
        });
      } else {
        this.functionCallingMethod(false, bulkAction);
      }
    },
    revertDc() {
      this.isLoading = true;
      this.tableData = [];
      this.DataManagementService.dataRevert(
        this.importData.customer,
        this.importId
      ).subscribe(() => {
        this.fetchProductTempData(this.stream, this.query);
        this.isLoading = false;
      }, this.handleRevertError);
    },
    fetchAutoValidDropDownVal(customerId) {
      try {
        this.DataManagementService.getProductAutoValidationMsg(
          this.importId,
          customerId
        ).subscribe(
          response => {
            if (this.importType == "Transactions") {
              this.dataValidationDropDownTD = this.prepareDropDownArray(
                response.validation_msg
              );
            } else {
              this.dataValidationDropDownPD = this.prepareDropDownValidationMsgArray(
                response.validation_msg
              );
            }
            this.productFamilyDropDown = this.prepareDropDownArray(
              response.product_family
            );
            this.packagingTypeDropDown = this.prepareDropDownArray(
              response.packaging_type
            );
            this.packagingLevelDropDown = this.prepareDropDownArray(
              response.packaging_level
            );
            this.chemistryDropDown = this.prepareDropDownArray(
              response.chemistry
            );
            this.productGroupDropDown = this.prepareDropDownArray(
              response.product_group
            );
            this.materialDetailDropDown = this.prepareDropDownArray(
              response.material_detail
            );
            this.materialGeneralDropdown = this.prepareDropDownArray(
              response.material_general
            );

            // After dropdown values are loaded, fetch CDF data
            this.fetchCDFDataBasedOnType();
          },
          e => {
            console.log(e);
            // Even on error, try to fetch CDF data with empty dropdowns
            this.fetchCDFDataBasedOnType();
          }
        );
      } catch (e) {
        console.log(e);
        // Even on error, try to fetch CDF data with empty dropdowns
        this.fetchCDFDataBasedOnType();
      }
    },
    fetchCDFDataBasedOnType() {
      if (this.importData && this.importData.import_type === "Transactions") {
        this.fetchCDFTrasactionData(this.importData.customer);
      } else if (this.importData) {
        this.fetchCDFProductData(this.customer_id);
      }
    },
    prepareDropDownArray(value) {
      const result = [];
      value.forEach(element => {
        const obj = {};
        obj["name"] = element;
        result.push(obj);
      });
      return result;
    },
    prepareDropDownValidationMsgArray(value) {
      const result = {};
      Object.keys(value).forEach(element => {
        result[element] && result[element].length > 0
          ? ""
          : (result[element] = []);
        value[element].forEach(e => {
          const obj = {};
          obj["name"] = e;
          result[element].push(obj);
        });
      });
      return result;
    },
    getClearFormObject() {
      return {
        customer: null,
        importType: "transaction",
        document: null
      };
    },
    reloadProductData() {
      this.tableData = [];
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
      this.fetchProductTempData(this.stream, this.query);
      //this.fetchCDFProductData(this.customer_id);
    },
    decodedString(encodedString) {
      // Decode the URL-encoded string
      return decodeURIComponent(encodedString);
    },
    togglePanel() {
      this.isOpen
        ? (this.subHeight = this.subHeight - 215)
        : (this.subHeight = this.subHeight + 215);
      this.checkSize();
      this.adjustHeight();
      return (this.isOpen = !this.isOpen);
    },
    getFileName(file) {
      const cleanFile = file.substring(file.lastIndexOf("/") + 1);
      return this.decodedString(cleanFile);
    },
    functionCallingMethod(value, bulkAction) {
      switch (bulkAction) {
        case "exportProducts":
          this.exportProducts();
          break;
      }
    },
    exportProducts() {
      try {
        const importType = this.importData.import_type;
        if (importType == "Products") {
          this.CDFProductDataService.exportProducts(
            this.customer_id,
            "tempProducts",
            this.stream,
            this.checkedData.map(records => records.id),
            this.totalRecords
          );
        } else {
          this.CDFTransactionDataService.exportTransactions(
            this.customer_id,
            "tempTransactions",
            this.checkedData.map(records => records.id),
            this.totalRecords
          );
        }
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Export is not possible",
          message: e.message
        });
      }
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
    },
    exportAll() {
      this.isLoading = true;
      try {
        const importType = this.importData.import_type;
        if (importType == "Products") {
          this.CDFProductDataService.exportAllProducts(
            this.customer_id,
            "tempProducts",
            this.stream,
            this.query,
            this.totalRecords
          );
        } else {
          this.CDFTransactionDataService.exportAllTransactions(
            this.customer_id,
            "tempTransactions",
            this.query,
            this.totalRecords,
            this.importData.id
          );
        }
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Export is not possible",
          message: e.message
        });
      }
      this.isCheckedAll = false;
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
    },
    additionalBulkCheck(bulkAction) {
      let msg = "";
      if (this.totalRecords < this.exportLargeCount) {
        msg =
          `Are you sure you want to export ` +
          (this?.isCheckedAll
            ? `all`
            : `selected ` + this?.checkedData?.length) +
          ` records?`;
      } else {
        msg =
          `Are you sure you want to export more than ` +
          this.exportLargeCount +
          ` records? Exported file will be sent to your email address`;
      }

      if (this.checkedData.length > 50 || this.isCheckedAll) {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          message: msg,
          trapFocus: true,
          onConfirm: value => this.exportAll(value, bulkAction)
        });
      } else {
        this.functionCallingMethod(false, bulkAction);
      }
    },
    downloadContent(file) {
      try {
        this.DataManagementService.downloadImportedFile(
          this.importId,
          this.getFileName(file.document)
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    editConfirm() {
      this.isModalActive = false;
      this.getCustomerById();
      //this.$router.go();
    },
    editCancel() {
      this.isModalActive = false;
    },
    viewModal(editObject) {
      this.action = "View";
      this.editObject = editObject;
      this.checkDependency(editObject);
      this?.importData?.import_type == "Transactions"
        ? (this.isModalActive = false)
        : (this.isModalActive = true);
    },
    editModal(editObject) {
      this.editObject = editObject;
      this.checkDependency(editObject);
      this.action = "Edit";
      this?.importData?.import_type == "Transactions"
        ? (this.isModalActive = false)
        : (this.isModalActive = true);
    },
    find_column_index(column_name) {
      return this.columns.findIndex(col => col.field === column_name);
    },
    pushValueToColumn(index, column_name, flag) {
      this.columns[index]["allStatusVals"] = [];
      if (
        flag == "materialDetail" &&
        this.materialDetail[`${column_name}`] &&
        this.materialDetail[`${column_name}`].length > 0
      ) {
        for (const element of this.materialDetail[`${column_name}`]) {
          this.columns[index]["allStatusVals"].push({
            name: element
          });
        }
      }
      if (
        flag == "productFamily" &&
        this.productFamily[`${column_name}`] &&
        this.productFamily[`${column_name}`].length > 0
      ) {
        for (const element of this.productFamily[`${column_name}`]) {
          this.columns[index]["allStatusVals"].push({
            name: element
          });
        }
      }
    },
    checkDependency(item) {
      const ProductFamilyIndex = this.find_column_index("product_family");
      if (ProductFamilyIndex > 0) {
        this.pushValueToColumn(
          ProductFamilyIndex,
          item.product_group,
          "productFamily"
        );
      }
      const materialDetailIndex = this.find_column_index("material_detail");
      if (materialDetailIndex > 0) {
        this.pushValueToColumn(
          materialDetailIndex,
          item.material_general,
          "materialDetail"
        );
      }
    },
    viewConfirmExport() {
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isBulkExportModal = false;
    },
    viewCancel() {
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isBulkExportModal = false;
    },
    updatedSingleProduct(editedObject) {
      this.DataManagementService.getOrUpdateProductData(
        this.customer_id,
        this.stream,
        this.$route.params.id,
        "isTemp",
        "",
        editedObject,
        true
      ).subscribe(response => {
        this.$buefy.toast.open({
          message: "Data is updated successfully!",
          type: "is-success"
        });
        this.fetchCDFImportData();
        this.isModalActive = false;
      }, this.handleApiError);
    },

    updateImportStatus(value) {
      this.DataManagementService.updateImportStatus(
        this.customer_id,
        this.importId,
        value
      ).subscribe(
        response => {
          this.fetchCDFImportData();
        },
        e => {
          console.log(e);
        }
      );
    },
    streamChanged() {
      // Only change the stream; do not save config automatically
      this.changeStream();
    },

    changeStream() {
      // Add a loading flag to prevent duplicate calls
      if (this.isStreamChanging) {
        return;
      }

      this.isStreamChanging = true;

      // Reset all data related to current stream
      this.tableData = [];
      this.totalRecords = 0;
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;

      // Clear table without triggering reload
      this.$refs.circul8Table.clearDataWithoutReload();

      // Prepare columns with stream-specific configuration
      this.prepareColumns(this.cdf_product_sheet, this.stream);

      // Fetch data for the selected stream
      this.fetchProductTempData(this.stream, this.query);

      // Reset loading flag after a slight delay to prevent multiple rapid calls
      setTimeout(() => {
        this.isStreamChanging = false;
      }, 500);
    },

    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;

      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        // Parse the URL to get clean parameters
        const url = new URL(this.nextPageCursor, window.location.origin);
        const params = new URLSearchParams(url.search);

        // Remove any existing page parameter and set the new one
        params.delete("page");
        params.set("page", this.currentPage + 1);

        // Generate a clean query string
        let queryString = params.toString();
        if (queryString) {
          queryString = "&" + queryString + "&";
        } else {
          queryString = "&page=" + (this.currentPage + 1) + "&";
        }

        this.query = queryString;

        if (this?.importData?.import_type == "Transactions") {
          this.fetchTrasactionTempData(this.query, "next");
        } else {
          this.fetchProductTempData(this.stream, this.query, "prev");
        }
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;

      // Update current page
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;

      if (this.PreviousPageCursor) {
        // Parse the URL to get clean parameters
        const url = new URL(this.PreviousPageCursor, window.location.origin);
        const params = new URLSearchParams(url.search);

        // Remove any existing page parameter and set the new one
        params.delete("page");

        if (this.currentPage == 0 || this.currentPage == 1) {
          params.set("page", 1);
          this.previousData = false;
        } else {
          params.set("page", this.currentPage);
        }

        // Generate a clean query string
        let queryString = params.toString();
        if (queryString) {
          queryString = "&" + queryString + "&";
        } else {
          queryString =
            "&page=" + (this.currentPage > 0 ? this.currentPage : 1) + "&";
        }

        this.query = queryString;
      } else {
        // If no previous cursor, create a simple page query
        this.query =
          "&page=" + (this.currentPage > 0 ? this.currentPage : 1) + "&";
      }

      if (this?.importData?.import_type == "Transactions") {
        this.fetchTrasactionTempData(this.query, "prev");
      } else {
        this.fetchProductTempData(this.stream, this.query, "prev");
      }
    },
    // ...existing code...
    prepareColumns(data, stream = "PRODUCT SHEET") {
      console.log("Preparing columns for stream:", stream);
      this.isDataLoading = true;
      let autoValidationMsg = "";
      // dynamically generate columns based on customer and stream
      const cdf_columns = data[0]["template_fields"];
      let cdf_product_sheet = [];
      if (stream == CDFStream.BATT) {
        autoValidationMsg = this.dataValidationDropDownPD["batt"];
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.BATT
        );
      } else if (stream == CDFStream.PACK) {
        autoValidationMsg = this.dataValidationDropDownPD["pack"];
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.PACK
        );
      } else if (stream == CDFStream.WEEE) {
        autoValidationMsg = this.dataValidationDropDownPD["weee"];
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.WEEE
        );
      } else if (stream == CDFStream.BUNDLE) {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.BUNDLE
        );
      } else if (stream == "Transactions") {
        cdf_product_sheet = cdf_columns;
        autoValidationMsg = this.dataValidationDropDownTD;
      } else {
        autoValidationMsg = this.dataValidationDropDownPD["product"];
        // Only include required fields for the current Products stream
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === "PRODUCT SHEET"
        );
        // Only include required fields for the current Products stream
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === "PRODUCT SHEET"
        );
      }
      this.columns = [];
      this.tableData = [];

      // Use a localStorage key that includes userId, customerId, importId, and stream for uniqueness
      const customerId =
        this.customer_id ||
        (this.importData && this.importData.customer_id) ||
        (this.customer && this.customer.id) ||
        this.$route.params.customerId;
      const importId =
        this.importId ||
        (this.importData && this.importData.id) ||
        this.$route.params.id;
      const storageKey = `validation-field-config-${
        this.userId
      }-customer-${customerId}-import-${importId}-stream-${stream.replace(
        /\s+/g,
        "_"
      )}`;

      // Only use the config for the current stream (no fallback)
      // Only use the config for the current stream (no fallback)
      const savedConfig = localStorage.getItem(storageKey);
      const savedVisibleFields = savedConfig ? JSON.parse(savedConfig) : null;

      // Always add customer_name column first
      this.columns.push({
        field: "customer_name",
        label: "Customer",
        searchable: true,
        filterKey: { customer_name: "" },
        type: "input",
        visible:
          savedVisibleFields == null
            ? true
            : savedVisibleFields.indexOf("customer_name") >= 0
      });

      cdf_product_sheet.forEach(e => {
        if (
          e.field_name == "WEEE" ||
          e.field_name == "BATT" ||
          e.field_name == "PACK" ||
          e.field_name == "COPY" ||
          e.field_name == "BUNDLE"
        ) {
          this.availableStream[e.field_name] = e.field_required;
        }
        if (
          (e.sheet_name == "BUNDLE INFORMATION") &
          (e.field_required == true)
        ) {
          this.availableStream["BUNDLE"] = true;
        }
        if (e.field_required == false) {
          return;
        }
        let type = "";
        let multiSelectFilter = "false";
        type = this.getFieldType(e.field_type);
        const filterKey = {};
        let allStatusVals = [];
        if (e?.dropdown_field_values?.length > 0) {
          e.dropdown_field_values.forEach(element => {
            if (e.product_data_column == "product_family") {
              Object.keys(element).forEach(key => {
                this.productFamily[`${key}`] = [];
              });
              this.productFamilyDropDown.forEach(val => {
                Object.keys(element).forEach(key => {
                  const value = element[key];
                  if (value.includes(val.name)) {
                    this.productFamily[`${key}`].push(val.name);
                  }
                });
              });
              allStatusVals = this.productFamilyDropDown;
            } else if (e.product_data_column == "material_detail") {
              Object.keys(element).forEach(key => {
                this.materialDetail[`${key}`] = [];
              });
              this.materialDetailDropDown.forEach(val => {
                Object.keys(element).forEach(key => {
                  const value = element[key];
                  if (value.includes(val.name)) {
                    this.materialDetail[`${key}`].push(val.name);
                  }
                });
              });
              allStatusVals = this.materialDetailDropDown;
            } else {
              allStatusVals.push({ name: element });
            }
          });
        }
        if (e.product_data_column == "product_group") {
          allStatusVals = this.productGroupDropDown;
        }
        if (e.product_data_column == "material_general") {
          allStatusVals = this.materialGeneralDropdown;
        }
        if (e.product_data_column == "packaging_type") {
          allStatusVals = this.packagingTypeDropDown;
        }
        if (e.product_data_column == "packaging_level") {
          allStatusVals = this.packagingLevelDropDown;
        }
        if (e.product_data_column == "chemistry") {
          allStatusVals = this.chemistryDropDown;
        }
        const editableCheck = e?.editable_check ? e.editable_check : false;
        const field_name =
          stream == "Transactions"
            ? e.transaction_data_column
            : e.product_data_column;
        const label_name =
          e.field_name.charAt(0).toUpperCase() +
          e.field_name.slice(1).toLowerCase();
        if (type == "multiSelectFilter") {
          multiSelectFilter = "true";
          filterKey[field_name] = [];
          filterKey["field_name"] = "name";
        } else {
          filterKey[field_name] = "";
        }

        const isVisible = savedVisibleFields
          ? savedVisibleFields.indexOf(field_name) >= 0
          : true; // default to visible if not in config

        // Prevent duplicate columns by field name
        if (!this.columns.some(col => col.field === field_name)) {
          this.columns.push({
            field: field_name,
            label: label_name,
            searchable: true,
            filterKey: filterKey,
            type: type,
            multiSelectFilter: multiSelectFilter,
            initStatusVals: [],
            allStatusVals: allStatusVals,
            editableCheck: editableCheck,
            width: "250",
            visible:
              savedVisibleFields == null
                ? true
                : savedVisibleFields.indexOf(field_name) >= 0
          });
        }
      });

      this.columns.sort((a, b) => a?.template_field - b?.template_field);

      if (stream !== "Transactions") {
        this.columns.push({
          field: "dc_applied",
          label: "Data Completion Applied",
          editableCheck: true,
          searchable: true,
          filterKey: {
            dc_applied: [],
            field_name: "name"
          },
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "dc_error",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          allStatusVals: [{ name: "yes" }, { name: "no" }],
          width: "200",
          visible: savedVisibleFields
            ? savedVisibleFields.indexOf("dc_applied") >= 0
            : true
        });
        this.columns.push({
          field: "data_comp_rules",
          label: "Data Completion Rule",
          searchable: true,
          editableCheck: true,
          filterKey: { data_comp_rules: "" },
          type: "input",
          width: "300",
          visible: savedVisibleFields
            ? savedVisibleFields.indexOf("data_comp_rules") >= 0
            : true
        });
        this.columns.push({
          field: "dc_created_at",
          label: "Data Completion Created At",
          searchable: true,
          editableCheck: true,
          filterKey: { dc_created_at: "" },
          type: "dateField",
          dateField: true,
          dateFilterKey: "dc_created_at_key",
          width: "200",
          visible: savedVisibleFields
            ? savedVisibleFields.indexOf("dc_created_at") >= 0
            : true
        });
        this.columns.push({
          field: "dc_by_name",
          label: "Data Completion Created By",
          searchable: true,
          editableCheck: true,
          filterKey: { dc_by_name: "" },
          type: "input",
          width: "200",
          visible: savedVisibleFields
            ? savedVisibleFields.indexOf("dc_by_name") >= 0
            : true
        });
      }
      this.columns.push({
        field: "data_validation",
        label: "Auto Validation",
        editableCheck: true,
        searchable: true,
        filterKey: {
          data_validation: [],
          field_name: "name"
        },
        type: "multiSelectFilter",
        multiSelectFilter: true,
        additionalInfo: true,
        allStatusVals: autoValidationMsg,
        additionalInfoIcon: "mdi  mdi-information",
        additionalInfoFieldName: "data_validation",
        visible: savedVisibleFields
          ? savedVisibleFields.indexOf("data_validation") >= 0
          : true
      });
      this.columns.push({
        field: "created_at",
        label: "Imported Date",
        editableCheck: true,
        searchable: true,
        filterKey: { created_at: "" },
        type: "dateField",
        dateField: true,
        dateFilterKey: "created_at_key",
        width: "200",
        visible: savedVisibleFields
          ? savedVisibleFields.indexOf("created_at") >= 0
          : true
      });

      this.columns.push({
        field: "updated_at",
        label: "Updated Date",
        editableCheck: true,
        searchable: true,
        filterKey: { updated_at: "" },
        type: "dateField",
        dateField: true,
        dateFilterKey: "updated_at_key",
        width: "200",
        visible: savedVisibleFields
          ? savedVisibleFields.indexOf("updated_at") >= 0
          : true
      });
      this.columns.push({
        field: "created_by_name",
        label: "Created By",
        editableCheck: true,
        searchable: true,
        filterKey: { created_by_name: "" },
        type: "input",
        width: "200",
        visible: savedVisibleFields
          ? savedVisibleFields.indexOf("created_by_name") >= 0
          : true
      });

      this.columns.push({
        field: "updated_by_name",
        label: "Updated By",
        editableCheck: true,
        searchable: true,
        filterKey: { updated_by_name: "" },
        type: "input",
        width: "200",
        visible: savedVisibleFields
          ? savedVisibleFields.indexOf("updated_by_name") >= 0
          : true
      });

      this.columns.push({
        field: "actions",
        label: "",
        sortable: 1,
        headerClass: "is-actions",
        cellClass: "is-actions",
        visible: true,
        searchable: true,
        type: "actionSearch",
        actionSearch: true,
        filterKey: { actions: "" }
      });

      // Always keep actions column visible
      this.columns.forEach(column => {
        if (column.field === "actions") {
          column.visible = true;
        }
      });

      this.isDataLoading = false;

      if (this?.importData?.import_type == "Transactions") {
        this.fetchTrasactionTempData("");
      } else {
        this.fetchProductTempData(stream, "");
      }
      this.cdf_product_config_sheet = cdf_product_sheet;
    },
    // ...existing code...,

    getFieldType(value) {
      switch (value) {
        case FieldType.TEXT:
          return "input";
        case FieldType.DATE:
          return "dateField";
        case FieldType.NUMBER:
          return "input";
        case FieldType.DROPDOWN:
          return "multiSelectFilter";
        case FieldType.NUMBERRANGE:
          return "numberRange";
        default:
          return "input";
      }
    },

    fetchProductTempData(stream, query = "", scrollDir) {
      // If already loading data, don't make another call
      if (this.isDataLoading && !scrollDir) {
        return;
      }

      this.isDataLoading = true;
      this.DataManagementService.getOrUpdateProductData(
        this.customer_id,
        stream,
        this.$route.params.id,
        "isTemp",
        query
      ).subscribe(
        response => {
          if (response["results"]) {
            this.PreviousPageCursor = this.nextPageCursor
              ? this.nextPageCursor
              : this.PreviousPageCursor;
            this.nextPageCursor = response["next"];
            if (this.currentPage > 1) {
              this.previousData = true;
              if (this.nextPageCursor != null) {
                this.enableLoadMore = this.nextData = true;
              } else {
                this.enableLoadMore = this.nextData = false;
              }
            } else {
              this.enableLoadMore = this.previousData = false;
              if (this.nextPageCursor != null) {
                this.enableLoadMore = this.nextData = true;
              } else {
                this.enableLoadMore = this.nextData = false;
              }
            }
            this.totalRecords = response["count"];
            let tempData = [];
            if (scrollDir == "next") {
              if (!this.nextPageCursor) {
                this.prepareData(response["results"]);
              } else {
                tempData = [...this.tableData, ...response["results"]];
                if (tempData.length > 100 && this.nextPageCursor != null) {
                  tempData = tempData.slice(50, 150);
                }
                this.prepareData(tempData);
              }
            } else if (scrollDir == "prev") {
              if (this.currentPage == 0) {
                this.prepareData(response["results"]);
              } else {
                tempData = [...response["results"], ...this.tableData];
                if (tempData.length >= 100) {
                  tempData = tempData.slice(0, 100);
                }
                this.prepareData(tempData);
              }
            } else {
              this.prepareData(response["results"]);
            }
          } else {
            this.prepareData(response);
          }
          this.isDataLoading = false;
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },
    prepareData(data) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        reportData["updated_at"] = this.dateToLocalDate(
          reportData["updated_at"]
        );
        reportData["created_at"] = dayjs(reportData["created_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        if (reportData["dc_created_at"]) {
          reportData["dc_created_at"] = this.dateToLocalDate(
            reportData["dc_created_at"]
          );
        }

        reportData["actions"] = "true";
        dataList.push(reportData);
      }

      if (this.nextPageCursor == null) {
        this.tableData.push(...dataList);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.tableData = dataList;
      }
      //if select all checkbox clicked the show all the data for the page as checked
      if (this.isCheckedAll) {
        this.checkedRow = this.tableData;
      } else {
        //else show the corresponding data from the dictionay map1
        const temp = [];
        // check if dictionary has value or not
        if (
          this.map1.get(this.currentPage) &&
          this.map1.get(this.currentPage).length > 0
        ) {
          //inserting data according to index of the current page
          this.map1.get(this.currentPage).forEach(element => {
            temp.push(this.tableData[element]);
          });
          this.checkedRow = temp;
        } else {
          this.checkedRow = [];
        }
      }
      this.checkSize();
      this.adjustHeight();
      this.isDataLoading = false;
    },
    fetchTrasactionTempData(query = "", scrollDir) {
      // If already loading data, don't make another call
      if (this.isDataLoading && !scrollDir) {
        return;
      }

      // Parse and clean the query to avoid duplicate import_id parameters
      let cleanQuery = query;

      // If query contains import_id, remove it to avoid duplication
      if (query && query.includes("import_id=")) {
        const params = new URLSearchParams(query.replace(/^&/, ""));
        params.delete("import_id");
        cleanQuery = params.toString();
        if (cleanQuery) {
          cleanQuery = "&" + cleanQuery;
        }
      }

      this.isDataLoading = true;
      this.DataManagementService.getTempTransactions(
        this.customer_id,
        this.importId,
        cleanQuery
      ).subscribe(
        response => {
          if (response["results"]) {
            this.PreviousPageCursor = this.nextPageCursor
              ? this.nextPageCursor
              : this.PreviousPageCursor;
            this.nextPageCursor = response["next"];
            if (this.currentPage > 1) {
              this.previousData = true;
              if (this.nextPageCursor != null) {
                this.enableLoadMore = this.nextData = true;
              } else {
                this.enableLoadMore = this.nextData = false;
              }
            } else {
              this.enableLoadMore = this.previousData = false;
              if (this.nextPageCursor != null) {
                this.enableLoadMore = this.nextData = true;
              } else {
                this.enableLoadMore = this.nextData = false;
              }
            }

            this.totalRecords = response["count"];
            let tempData = [];
            if (scrollDir == "next") {
              if (!this.nextPageCursor) {
                this.prepareData(response["results"]);
              } else {
                tempData = [...this.tableData, ...response["results"]];
                if (tempData.length > 100 && this.nextPageCursor != null) {
                  tempData = tempData.slice(50, 150);
                }
                this.prepareData(tempData);
              }
            } else if (scrollDir == "prev") {
              if (this.currentPage == 0) {
                this.prepareData(response["results"]);
              } else {
                tempData = [...response["results"], ...this.tableData];
                if (tempData.length >= 100) {
                  tempData = tempData.slice(0, 100);
                }
                this.prepareData(tempData);
              }
            } else {
              this.prepareData(response["results"]);
            }
          } else {
            this.prepareData(response);
          }
          this.isDataLoading = false;
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },
    fetchCDFTrasactionData(customer_id) {
      this.isDataLoading = true;
      this.cdf_product_sheet = [];
      //here sending true for geting NA values for dropdowns
      this.CDFTransactionDataService.getCdfTransactionField(
        customer_id,
        true
      ).subscribe(
        response => {
          this.cdf_product_sheet = response;
          if (response.length > 0) {
            this.prepareColumns(response, "Transactions");
          }
          //this.isDataLoading = false;
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },

    fetchCDFProductData(customer_id) {
      this.isDataLoading = true;
      this.cdf_product_sheet = [];
      console.log("Fetching CDF Product Data for customer_id:", customer_id);

      this.CDFProductDataService.getAll(customer_id, true).subscribe(
        response => {
          this.cdf_product_sheet = response;
          if (response.length > 0) {
            this.prepareColumns(response, this.stream);
          }
          // this.isDataLoading = false;
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },
    fetchCDFImportData() {
      this.isDataLoading = true;
      this.currentPage = 0;
      this.DataManagementService.getImportById(this.importId).subscribe(
        response => {
          this.importData = response;
          this.customer_id = this.importData?.customer
            ? this.importData?.customer
            : 0;
          this.parent_customer_id = this.importData?.parent_customer;

          // When importing new product validation data, ensure we start with all columns visible
          this.columns = [];

          // Wait for dropdown values to be fetched before preparing columns
          this.fetchAutoValidDropDownVal(this.customer_id);
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },
    showComments(value) {
      this.$buefy.dialog.alert({
        title: "Comments",
        message: value,
        confirmText: "Close",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },

    handleApiError(reason) {
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        } else {
          errorMessage = "Some issue while updating status";
        }
      }
      this.isLoading = false;
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    handleRevertError(reason) {
      let errorMessage = reason.response.data["detail"];
      this.isLoading = false;
      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Some issue while updating status";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.fetchProductTempData(this.stream, this.query);
    },

    validateData() {
      this.isStatusLoading = true;
      this.isCardModalActive = false;
      const customer_id = this.customer_id ? this.customer_id : 0;
      this.DataManagementService.validateOrDiscardData(
        this.importId,
        customer_id,
        this.tempWorkflowStatus,
        this.importType
      ).subscribe(response => {
        this.$buefy.toast.open({
          message: "CDF Workflow status updated Successfully",
          type: "is-success"
        });
        this.routeToRespectivePage(this.importType);
        this.isStatusLoading = false;
      }, this.handleStatusApiError);
    },
    handleStatusApiError(reason) {
      this.isStatusLoading = false;
      this.handleApiError(reason);
    },

    validateDataConfirm() {
      if (this.tempWorkflowStatus == ImportCDFWorkflowStatus.DISCARDED) {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          message: `All imported data will be erased, do you want to continue ?`,
          trapFocus: true,
          onConfirm: value => this.validateData()
        });
      } else {
        this.validateData();
      }
    },

    backToImport() {
      this.$router.push({
        name: "datamanagement.import"
      });
    },
    tempStatusChange() {
      this.validateDataConfirm();
    },
    checkedAllData(value) {
      this.isCheckedAll = value;
      if (!this.isCheckedAll) {
        this.checkedRow = [];
        this.map1 = new Map();
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
      } else {
        this.checkedDataMap.set(this.currentPage, this.tableData);
      }
    },
    checkCheckBox(d) {
      // select all should be false now
      const total_checked = this.checkedData.length;
      const indexes = [];
      //getting the index of the checked rows
      d.forEach(element => {
        const index = this.tableData.findIndex(object => {
          return element.id === object.id;
        });
        indexes.push(index);
      });
      // create 2 dictionary. one with indexes for showing current page selected another with checked row value
      this.map1.set(this.currentPage, indexes);

      if (d.length > 0) {
        this.checkedDataMap.set(this.currentPage, d);
      } else {
        !this.isCheckedAll && this.checkedDataMap.set(this.currentPage, d);
      }
      this.checkedRow = d;
      this.checkedData = [];
      // converting mapped data into array for bulk operations
      this.checkedDataMap.forEach(element => {
        this.checkedData.push(...element);
      });
      // if checked all is true and deselect any
      if (this.isCheckedAll && total_checked > this.checkedData.length) {
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
        this.map1 = new Map();
      }
    },
    searchByFilter(filterQuery) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
      this.query = "&" + filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      // Maintaining sort column & order in separate varaibles instead of this.query as it becomes difficult to replace & maintain
      // sort column & order part of this.query string. We should maintain query params in associative array instead of string
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn + "&";
        query += "&order_by" + "=" + this.lastSortOrder + "&";
        query += this.query;
      } else {
        query = this.query;
      }
      if (this?.importData?.import_type == "Transactions") {
        this.fetchTrasactionTempData(query);
      } else {
        this.fetchProductTempData(this.stream, query);
      }
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.nextData = false;
      this.currentPage = 0;
      this.tableData = [];
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");

      const oldOrderField = "&order_field" + "=" + this.lastSortColumn + "&";
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder + "&";
      const newOrderField = "&order_field" + "=" + field + "&";
      const newOrderValue = "&order_by" + "=" + order + "&";

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      if (this?.importData?.import_type == "Transactions") {
        this.fetchTrasactionTempData(this.query);
      } else {
        this.fetchProductTempData(this.stream, this.query);
      }
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      // Extract parameter name (key) for both old and new parameters
      const getParamName = paramStr => {
        const matches = paramStr.match(/&([^=]+)=/);
        return matches ? matches[1] : null;
      };

      const oldParamName = getParamName(oldParam);

      // If the parameter already exists, remove it first (all instances)
      if (oldParamName && this.query.includes(`&${oldParamName}=`)) {
        // Use regex to remove all instances of the parameter
        const regex = new RegExp(`&${oldParamName}=[^&]*`, "g");
        this.query = this.query.replace(regex, "");
      }

      // Add the new parameter
      this.query += newParam;

      return this.query;
    },

    checkCurrentStatus(value) {
      if (this.importData?.status === value) {
        return true;
      }
      return false;
    },

    routeToRespectivePage(importType) {
      const routeName = "datamanagement." + importType.toLowerCase();
      const routeCustomer =
        this.parent_customer_id != null
          ? this.parent_customer_id
          : this.customer_id;
      this.$router.push({
        name: routeName,
        params: {
          customerId: routeCustomer
        }
      });
    },

    routeToImport() {
      this.$router.push({
        name: "datamanagement.import"
      });
    },

    checkSize() {
      screenPixelSize = screen.width;
      pixelRatio =
        window.devicePixelRatio ||
        window.screen.availWidth / document.documentElement.clientWidth;
      pixelRatio = pixelRatio.toFixed(1);
      if (
        (screenPixelSize > 1024 &&
          screenPixelSize < 1281 &&
          pixelRatio == 1.5) ||
        (screenPixelSize > 1580 && screenPixelSize < 1921 && pixelRatio == 1.5)
      ) {
        this.subHeight = this.subHeight - 15;
      }
      this.$refs.circul8Table.$refs.multiselect &&
        this.$refs.circul8Table.$refs.multiselect.forEach(element => {
          element.deactivate();
        });
      this.$refs.circul8Table.$refs.dropdown &&
        this.$refs.circul8Table.$refs.dropdown.forEach(element => {
          element.isActive = false;
        });
      this.$refs.circul8Table.$refs.datePicker &&
        this.$refs.circul8Table.$refs.datePicker.forEach(element => {
          element.closePopup();
        });
    },

    adjustHeight() {
      const browser_height = window.innerHeight;
      const newTableHeight = browser_height - this.subHeight;
      document.querySelector(".table-wrapper").style.maxHeight =
        newTableHeight + "px";
    },
    submit() {
      this.DataManagementService.addMoreData(
        this.importData.id,
        this.importData.import_type,
        this.customer_id,
        this.addDataDocument
      ).subscribe(() => {
        this.$buefy.dialog.confirm({
          title: "Success",
          message: "Import triggered successfully.",
          onConfirm: this.routeToImport()
        });
        this.isNewDataFileListActive = false;
      }, this.handleApiError);
    }
  }
};
</script>
